const BOM = '\uFEFF';
export const CSV_DELIMITER = ';';

export function csvValue(value: string | number | boolean | null | undefined): string {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function createCsv(headers: string[], rows: Array<Array<string | number | boolean | null | undefined>>): string {
  return BOM + [headers, ...rows].map((row) => row.map(csvValue).join(CSV_DELIMITER)).join('\r\n');
}

export function minorToDecimal(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return (value / 100).toFixed(2);
}
